import type { RouteRecordRaw } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "@/store";
import Application from "@/views/Application.vue";
import ApplicationRefi from "@/views/ApplicationRefi.vue";
import OidcCallback from "../views/OidcCallback.vue";
import OidcCallbackError from "../views/OidcCallbackError.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/application",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/application",
    name: "Application",
    component: Application,
    beforeEnter: (to, from, next) => {
      const product = localStorage.getItem("product");
      const productTypeId = to.query.productTypeId;

      if (productTypeId === "1" || (!productTypeId && product === "1")) {
        to.matched[0].components = { default: Application };
        next();
      } else if (productTypeId === "2" || (!productTypeId && product === "2")) {
        to.matched[0].components = { default: ApplicationRefi };
        next();
      } else if (productTypeId === "3" || (!productTypeId && product === "3")) {
        to.matched[0].components = { default: Application };
        next();
      } else {
        next(false);
      }
    },
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/application/:productTypeId",
    name: "ApplicationRefi",
    component: () => import(/* webpackChunkName: "about" */ "../views/ApplicationRefi.vue"),
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/invite/accept",
    name: "Invite",
    component: () => import(/* webpackChunkName: "about" */ "../views/Invite.vue"),
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/return",
    name: "Return",
    component: () => import(/* webpackChunkName: "about" */ "../views/Return.vue"),
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/ecommunications",
    name: "ecommunications",
    component: () => import(/* webpackChunkName: "protected" */ "../views/ECommunications.vue"),
    meta: {
      isPublic: true,
      title: "ECommunications",
    },
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import(/* webpackChunkName: "protected" */ "../views/TermsAndConditions.vue"),
    meta: {
      isPublic: true,
      title: "Terms & Conditions",
    },
  },
  {
    path: "/mobileCommunications",
    name: "mobileCommunications",
    component: () => import(/* webpackChunkName: "protected" */ "../views/MobileCommunications.vue"),
    meta: {
      isPublic: true,
      title: "Mobile Communications",
    },
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import(/* webpackChunkName: "protected" */ "../views/PrivacyPolicy.vue"),
    meta: {
      isPublic: true,
      title: "Privacy Policy",
    },
  },
  {
    path: "/accessibility",
    name: "accessibility",
    component: () => import(/* webpackChunkName: "protected" */ "../views/Accessibility.vue"),
    meta: {
      isPublic: true,
      title: "Accessibility",
    },
  },
  {
    path: "/federalLoanDisclosure",
    name: "federalLoanDisclosure",
    component: () => import(/* webpackChunkName: "protected" */ "../views/FederalLoanDisclosure.vue"),
    meta: {
      isPublic: true,
      title: "Federal Loan Disclosure",
    },
  },
  {
    path: "/oidc-callback", // Needs to match redirectUri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
      title: "Redirecting...",
    },
  },
  {
    path: "/oidc-callback-error", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallbackError",
    component: OidcCallbackError,
    meta: {
      isPublic: true,
      title: "Error",
    },
  },
];

// Function to remove a specific parameter (e.g., 'search')
export const removeSpecificParam = (param: string) => {
  const query = { ...router.currentRoute.value.query };
  delete query[param];
  router.replace({ query });
};

export const resetParams = () => {
  router.replace({ query: {} });
};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from) => {
  console.log("router beforeEach", { to, from, store });
  // #TODO figure out how we will prevent users from changing productTypeIds
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store, "oidcStore"));

export default router;
